import styled from 'styled-components';
import { zIndex } from 'tokens';

interface BaseProps {
	semiTransparent: boolean;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${({ theme, semiTransparent }) =>
		semiTransparent ? `${theme.gray[0]}DD` : theme.gray[0]};
	z-index: ${zIndex.loading};
`;

export const Container = styled.div`
	position: absolute;
	height: 300px;
	width: 90%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	z-index: ${zIndex.loading};
`;

export const LoaderWrapper = styled.div`
	width: 32px;
	height: 32px;
`;

export const Text = styled.div`
	font-weight: 400;
	line-height: 1.5;
	font-size: 20px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const ErrorWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	flex-direction: column;
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 12px;
	font-size: 16px;
	text-decoration: underline;
	text-underline-offset: 2px;
	text-decoration-thickness: 0.5px;
	font-weight: 200;
	opacity: 0.7;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 1;
	}
`;
